module.exports = __webpack_public_path__ + "img/yingyongguanli.8f99ad08.png";